import { z } from "zod";

export const referralSourceSchema = z.object({
  id: z.number(),
  name: z.string(),
});
